import React from 'react';
import Select from 'react-select';
import { useDebouncedCallback } from 'use-debounce';

const DropDownMultiSelect = ({ options, defaultText, value, onchange, paramkey, search }) => {
  const handleChange = (selectedOptions) => {
    // selectedOptions will be an array in multi-select mode
    const selectedValues = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];

    if (onchange) {
      onchange(selectedValues); // pass array of selected IDs
    }
  };

  const formattedOptions = (options || []).map((e) => ({
    value: String(e.id),
    label: e.name,
  }));

  // Ensure value is an array for multi-select
  const selectedOptions = Array.isArray(value)
    ? formattedOptions.filter((opt) => value.map(String).includes(opt.value))
    : [];

  return (
    <Select
      isMulti // ✅ Enables multi-select mode
      name={paramkey}
      options={formattedOptions}
      placeholder={defaultText}
      onChange={handleChange}
      className="w-full bg-thirdly border border-gray-500/100 rounded-md"
      value={selectedOptions}
      isSearchable={true}
      styles={{
        control: (provided) => ({
          ...provided,
          backgroundColor: '#212529',
          color: 'white',
          minHeight: 40,
          border: 'none',
        }),
        placeholder: (provided) => ({
          ...provided,
          color: 'white',
        }),
        singleValue: (provided) => ({
          ...provided,
          color: 'white',
        }),
        multiValue: (provided) => ({
          ...provided,
          backgroundColor: '#433b61',
          color: 'white',
        }),
        multiValueLabel: (provided) => ({
          ...provided,
          color: 'white',
        }),
        input: (provided) => ({
          ...provided,
          color: 'white',
        }),
      }}
    />
  );
};

export default DropDownMultiSelect;
